import { Grid } from '@material-ui/core';
import { WorkOutline } from '@material-ui/icons';
import { ItemDisplay } from 'libs/feature-one-tool/src/quote/components/itemDisplay';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { OneToolCardBorder } from './oneToolCard';
import { RoundedBackgroundIcon } from './roundedBackgroundIcon';

export const EntityInformationSummaryCard = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  const { borrowerEntityInformationStore } = loanTypeStore;
  const { borrowerEntityFormStore } = borrowerEntityInformationStore;
  const entity = borrowerEntityFormStore.getFormValues();

  return (
    <OneToolCardBorder>
      <Grid container justifyContent="space-between" alignItems="center">
        <Grid item xs={5}>
          <Grid
            container
            spacing={2}
            justifyContent="flex-start"
            alignItems="center"
            style={{ flexWrap: 'nowrap' }}
          >
            <Grid item alignItems="center" style={{ height: '100%' }}>
              <RoundedBackgroundIcon Icon={WorkOutline} iconColor="#6D6D6D" />
            </Grid>
            <Grid item style={{ maxWidth: '100%' }}>
              <ItemDisplay
                label="Entity Name"
                value={entity.name || '-'}
                alignItems="flex-start"
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={7}>
          <Grid
            container
            spacing={3}
            justifyContent="flex-end"
            alignItems="center"
          >
            <Grid item>
              <ItemDisplay label="Entity EIN" value={entity.ein || '-'} />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </OneToolCardBorder>
  );
});
